import React from 'react';
import InputFactory from './input-factory';
import { Justify } from 'tea-component';
import {
  keywordCorrelationMinCorrelationTips,
  keywordCorrelationMinFrequencyTips,
} from '@/pages/opinion/components/BubbleCommon';
import { useIntl } from 'umi';
import './index.scss';

export default function Component({ onChange }) {
  const handleOnChange = (key: string, value: any) => {
    onChange?.(key, value);
  };

  const { formatMessage } = useIntl();

  return (
    <Justify
      left={
        <div className="dbo-correlation-cloud-seletbox"
        >
          <InputFactory
            tipsMap={keywordCorrelationMinCorrelationTips}
            defaultValue={''}
            defaultParams={{
              btnTextPrefix: formatMessage({ id: 'Min Correlation' }),
            }}
            errorConfig={{
              max: 20,
              min: 0,
              tip: (
                <>
                  {formatMessage(
                    {
                      id: 'The value of Min Correlation must be more than {min} and less than {max}.',
                    },
                    {
                      min: 0,
                      max: 20,
                    },
                  )}
                </>
              ),
            }}
            valueKey="correlation"
            valueType="number"
            onChange={handleOnChange}
          ></InputFactory>
          <InputFactory
            tipsMap={keywordCorrelationMinFrequencyTips}
            defaultValue={3}
            defaultParams={{
              btnTextPrefix: formatMessage({ id: 'Min Frequency' }),
            }}
            errorConfig={{
              max: Infinity,
              min: 0,
              tip: (
                <>
                  {formatMessage(
                    { id: 'Enter an integer greater than {min}.' },
                    { min: 0 },
                  )}
                </>
              ),
            }}
            valueKey="frequency"
            valueType="integer"
            onChange={handleOnChange}
          ></InputFactory>
        </div>
      }
    ></Justify>
  );
}
